import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '../../../ui/src/component/icon';
import './nowPlaying.css';
import noImg from './../../../assets/no-image-small.png';
import { getProp } from '../../../ui/src/utilities';

const NowPlaying = (props) => {
  const youtubeUrl = getProp(props.item, 'youtube.url', null);
  const image = getProp(props.item, 'youtube.thumbnail', noImg);

  return (
    <div className="now-playing">
      <div className="now-playing-container">
        <div className="now-playing-content">
          <div className="right-text">Teraz</div>
          <div className="text-ellipsis">{props.item.title}</div>
        </div>
      </div>
      {youtubeUrl ? (
        <a
          href=""
          className="np-button"
          onClick={(e) => {
            e.preventDefault();
            if (youtubeUrl && window && window.ga) {
              window.ga('send', 'event', 'playlist', 'play', props.item.title);
              props.onClickYoutube(
                Object.assign({}, getProp(props.item, 'youtube', {}), {
                  title: props.item.title,
                }),
              );
            }
          }}
        >
          <div
            className="np-thumb"
            style={{ backgroundImage: "url('" + image + "')" }}
          />
          {youtubeUrl !== null ? <Icon name="play" size="md" /> : null}
        </a>
      ) : (
        <div className="np-button">
          <div
            className="np-thumb"
            style={{ backgroundImage: "url('" + image + "')" }}
          />
        </div>
      )}
    </div>
  );
};

NowPlaying.propTypes = {
  item: PropTypes.object.isRequired,
  onClickYoutube: PropTypes.func.isRequired,
};

export default NowPlaying;



// WEBPACK FOOTER //
// ./src/app/component/nowPlaying/nowPlaying.js